import React from "react";
import { Grid, TextField } from "@mui/material";

const CoordinateSection = ({ lat, lng, onChange, error }) => (
  <>
    <Grid item xs={6}>
      <TextField
        label="Latitude"
        fullWidth
        value={lat}
        onChange={(e) => onChange("lat", e.target.value)}
        error={!!error}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Longitude"
        fullWidth
        value={lng}
        onChange={(e) => onChange("lng", e.target.value)}
        error={!!error}
        helperText={error}
      />
    </Grid>
  </>
);

export default CoordinateSection;
